import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SelectForm } from "../../../../../common/Buttons";
import { Input, Alert } from "antd";
import { phonenumberValid } from "../../../../../../helpers/Utils";
import { createSmsItem } from "../../../../../../redux/Actions/orderAction";
import { ClassicButton } from "../../../../ButtonWithLoading";
import useFetch from "../../../../../../hooks/useFetch";
import { fetch_sms_sendings_by_order_id } from "../../../../../../redux/Actions/sms_sending_action";
import { setCountriesOptions } from "../../../../../../redux/Actions/options_action";
import ListSmsSendings from "../../../../../table/ListSmsSendings";

const { TextArea } = Input;

function SmsSending({ id, phoneNumber, shipments, country_id, shop_identifier }) {
  const { countries } = useSelector((state) => state.options);
  const dispatch = useDispatch();
  const [countryId, setCountryId] = useState(country_id || undefined);

  useEffect(() => {
    setCountryId(country_id);
  }, [country_id]);

  useEffect(() => {
    dispatch(setCountriesOptions());
  }, []);

  const { value } = useFetch(`/api/v1/sms_templates?q[technorama_true]=${shop_identifier == "TCH" ? 1 : 0}`);

  const sms_templates =
    value?.data?.map((e) => ({
      value: e.body,
      label: e.message,
      country_id: e.country_id,
    })) || [];

  const sms_sendings = useSelector((state) => state.orders.sms_sendings);
  const [bodyText, setBodyText] = useState("");
  const [bodyTextID, setBodyTextID] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const [alertText, setAlertText] = useState({
    success: "success",
    text: "",
    show: false,
  });

  const sendSms = () => {
    setLoading(true);
    const variables = {
      body: bodyText,
      number: phoneNumber,
    };

    dispatch(createSmsItem(id, variables)).then((res) => {
      if (res.success) {
        setLoading(false);
        setAlertText({
          success: "info",
          text: "SMS sending.",
          show: true,
        });
        setBodyText("");
        dispatch(fetch_sms_sendings_by_order_id(id, res.sms_sending_id)).then(
          (res) => {
            if (res.success) {
              setAlertText({
                success: "success",
                text: "SMS sended successfully.",
                show: true,
              });
            }
          }
        );
      } else {
        setLoading(false);
        setAlertText({
          success: "error",
          text: "An error occurred.",
          show: true,
        });
      }
    });
  };

  const setSmsText = (evt, arg) => {
    let value = evt;
    if (value.search("[linkas i trakinima]") !== -1) {
      let courier_trackings = [];
      let courier_trackings_number = [];
      shipments.forEach((ship) => {
        ship.courier_trackings.forEach((track) => {
          courier_trackings.push(track.url);
          courier_trackings_number.push(track.number);
        });
      });
      if (courier_trackings.length === 1) {
        value = value.split("#[linkas i trakinima]").join(courier_trackings[0]);
        if (value.search("[siuntos numeris]")) {
          value = value
            .split("#[siuntos numeris]")
            .join(courier_trackings_number[0]);
        }
      } else if (courier_trackings.length > 1) {
        value = value
          .split("#[linkas i trakinima]")
          .join(courier_trackings.join(", "));
        if (value.search("[siuntos numeris]")) {
          value = value
            .split("#[siuntos numeris]")
            .join(courier_trackings_number.join(", "));
        }
      }
    }

    setBodyTextID(arg.children);
    setBodyText(value);
  };

  return (
    <div className="col-12 bg-silver">
      {alertText.show && (
        <Alert
          className="mt-2"
          message={alertText.text}
          type={alertText.success}
          showIcon
        />
      )}
      <div className="pt-2 mb-2">
        <SelectForm
          onlyPlaceholder="Country"
          options={countries}
          onChange={(value) => {
            setCountryId(value);
            setBodyText("");
            setBodyTextID(undefined);
          }}
          value={countryId}
        />
      </div>
      <div className="mb-2">
        <SelectForm
          disabled={!countryId}
          onlyPlaceholder="Templates"
          options={sms_templates.filter((e) => e.country_id == countryId)}
          onChange={(evt, arg) => setSmsText(evt, arg)}
          value={bodyTextID}
        />
      </div>
      <div>
        <div style={{ width: "100%" }}>
          <TextArea
            placeholder="Text"
            value={bodyText}
            autoSize={{ minRows: 2, maxRows: 6 }}
            onChange={(e) => setBodyText(e.target.value)}
          />
        </div>
        <div
          style={{
            width: "100%",
            marginTop: "5px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          {phonenumberValid(phoneNumber) && (
            <ClassicButton loading={loading} text="Send" onClick={sendSms} />
          )}
        </div>
      </div>
      <table className="table table-hover mt-3">
        <ListSmsSendings sms_sendings={sms_sendings} />
      </table>
    </div>
  );
}

export default SmsSending;
